<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputSelect
        v-model="data"
        :options="optionsPropertyConstructionType"
        :db="db"
        :args="args"
        :skipped="skipped"
        :js-errors="jsErrors"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { propertyOptions } from "../../../options/propertyOptions";

import QuestionBase from "../../../QuestionBase";
import InputSelect from "../../../inputs/InputSelect";

export default {
  name: 'ConstructionType',
  mixins: [propertyOptions, questionLoadHelpers],
  components: {
    InputSelect,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'What type of construction is the property?',
        subTitle:  null,
        tip: null,
      },
      db: {
        saveLocation: 'mortgage_property_save',
        saveField: 'construction_type'
      },
      args: {
        taggable: false,
        label: null,
        placeholder: 'Please select..',
        skippable: true,
        required: true,
        inputClass: 'field-66'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>